<div class="kfm-article-create-edit-dialog" [hsLayer]="'one'">
  <hs-form-field>
    <hs-form-label>{{ shortTextLabel }}</hs-form-label>
    <input
      hsInput
      [placeholder]="shortTextLabel"
      [value]="title()"
      (change)="onTitleChanged($event.target.value)"
    />
  </hs-form-field>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(selectedArticle)"
      [disabled]="!canSave"
    >
      {{ okLabel }}
    </button>
  </div>
</div>
